export const COOKIE_KEYS = {
  REFRESH_TOKEN: 'refresh_token',
  AUTH_TOKEN: 'auth_token',
} as const;
